import React from "react";

const PrivacyPolicy = () => (
  <div className="w-3/4 mx-auto my-10">
    <h1 className="text-center">Privacy Policy</h1>
    <p>
      Last Updated: 2023-10-01 - Google Developer Groups ("GDG"){" "}
      {process.env.REACT_APP_CHAPTER_NAME}.
    </p>
    <br />
    <br />
    <p>
      All participants of GDG {process.env.REACT_APP_CHAPTER_NAME} events must
      abide by the following policy:
    </p>
    <h2>1. Introduction</h2>
    <p>
      Welcome to the devfestlondon mobile app for iOS and Android (“App”), we
      value your privacy and is committed to protecting your personal
      information. This Privacy Policy is designed to help you understand how we
      collect, use, disclose, and safeguard your data when you use our App. You
      agree to the terms and practices described in this Privacy Policy by
      downloading, installing, or using the App.
    </p>

    <h2>2. Information We Collect</h2>
    <p>
      We may collect various types of information when you use our App,
      including:
    </p>

    <h2>2.1 Personal Information</h2>
    <p>
      Contact Information: When you create an account or use certain App
      features, we may collect your name, email address, and other contact
      details. User Content: Any content you choose to post, upload, or share
      within the App, including text, images, and other media, may be collected
      by us.
    </p>

    <h2> 2.2 Usage Information</h2>
    <p>
      Device Information: We may collect information about your device to access
      the App, including device type, operating system, and unique device
      identifiers. Usage Data: We collect data related to your interactions with
      the App, such as your activity, preferences, and settings.
    </p>
    <h2>2.3 Location Information</h2>
    <p>
      With your consent, we may collect and process your device’s precise
      location information to provide location-based services within the App.
    </p>
    <h2>3. How We Use Your Information</h2>
    <p>
      We use the collected information for various purposes, including but not
      limited to:
    </p>
    <h2>3.1 Providing Services</h2>
    <p>
      To deliver the features and functionalities of the App to you. To process
      transactions and fulfil your orders.
    </p>
    <h2> 3.2 Communication</h2>
    <p>
      To respond to your inquiries, requests, or customer support inquiries. To
      send you updates, notifications, and information related to the App or
      your account.
    </p>
    <h2>3.3 Analytics and Improvement</h2>
    <p>
      To analyse usage patterns, trends, and performance of the App to enhance
      its functionality and user experience. To conduct research and development
      activities to improve our services.
    </p>
    <h2>3.4 Legal and Security</h2>
    <p>
      To comply with legal obligations and respond to legal requests. To
      prevent, detect, and address fraud, security breaches, or violations of
      our terms of service.
    </p>
    <h2>4. Sharing Your Information</h2>
    <p>
      We may share your information with the following parties, as necessary for
      the purposes outlined in this Privacy Policy: Service Providers: We may
      engage third-party service providers to assist us in delivering and
      improving our services, such as payment processors and analytics
      providers. Legal Compliance: We may share your information with law
      enforcement, regulatory authorities, or other third parties when required
      by applicable laws, court orders, or legal processes. Business Transfers:
      In the event of a merger, acquisition, or sale of all or part of our
      assets, your information may be transferred as part of the transaction.
    </p>

    <h2>5. Data Security</h2>
    <p>
      We take appropriate measures to protect your personal information from
      unauthorised access, disclosure, alteration, or destruction. However,
      please be aware that no data transmission over the Internet or data
      storage method can be guaranteed 100% secure.
    </p>

    <h2>6. Your Choices and Rights</h2>
    <p>
      You have certain rights regarding your personal information, including the
      right to access, correct, delete, or limit the processing of your data.
      You may also have the right to object to processing your data or request
      data portability.
    </p>

    <h2>7. Changes to this Privacy Policy</h2>
    <p>
      We may update this Privacy Policy occasionally to reflect changes in our
      practices or for other operational, legal, or regulatory reasons. We will
      notify you of any changes to this Privacy Policy through the App or other
      means.
    </p>

    <h2>8. Contact Us</h2>
    <p>
      If you have any questions, concerns, or requests related to this Privacy
      Policy or your personal information, please contact us at:
      hello@gdglondon.dev
    </p>

    <h2>9. Consent</h2>
    <p>
      By downloading, installing, or using the devfestlondon iOS or Android
      mobile app, you consent to collecting, using, and sharing your information
      as described in this Privacy Policy. Please read this Privacy Policy
      carefully and ensure you agree with its terms before using the App.
    </p>
  </div>
);

export default PrivacyPolicy;
